'use client';
import React from 'react';
import Link from 'next/link';

export default function FeaturedBanner() {
  return (
    <Link
      href="#featured-event"
      className="block cursor-pointer group"
      style={{ margin: '0 48px', marginBottom: '16px' }}>
      
      <div
        className="relative overflow-hidden"
        style={{
          background: '#1A0A00',
          borderRadius: '16px',
          minHeight: '220px',
          border: '1px solid rgba(201,168,76,0.3)',
          boxShadow: '0 4px 24px rgba(0,0,0,0.3)',
        }}>
        
        {/* Gold top accent */}
        <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: '2px', background: 'linear-gradient(to right, transparent, #C9A84C, #E8C97A, #C9A84C, transparent)', zIndex: 20 }} />

        {/* Background image */}
        <div className="absolute inset-0">
          <img
            src="https://img.rocket.new/generatedImages/rocket_gen_img_11a8f7fce-1775205795850.png"
            alt="Global Music Festival 2025 featured event with spectacular stage and crowd"
            className="w-full h-full object-cover opacity-20 transition-transform duration-700 group-hover:scale-105" />
          
          <div
            className="absolute inset-0"
            style={{
              background:
              'linear-gradient(to right, rgba(26,10,0,0.97) 45%, rgba(26,10,0,0.4) 100%)'
            }} />
          
        </div>

        {/* Content */}
        <div className="relative z-10 flex flex-col md:flex-row items-center justify-between p-8 md:p-12 gap-6">
          <div className="flex-1">
            <div
              className="inline-flex items-center px-2.5 py-0.5 rounded mb-3"
              style={{ background: 'linear-gradient(135deg, #C9A84C, #8B6914)', borderRadius: '4px' }}>
              
              <span
                className="text-[11px] font-bold"
                style={{ letterSpacing: '1.5px', color: '#FAF7F2', fontFamily: 'Roboto, sans-serif' }}>
                
                NEW
              </span>
            </div>
            <h2
              className="text-3xl md:text-4xl font-bold mb-2 leading-tight"
              style={{ fontFamily: '"Playfair Display", Georgia, serif', color: '#E8C97A' }}>
              
              Rani Kamlapati Premium
            </h2>
            <p className="text-base mb-6" style={{ color: 'rgba(250,247,242,0.65)' }}>
              Unlock VIP access, early bird tickets, and exclusive member-only events.
            </p>
            <span
              className="inline-flex items-center gap-2 text-sm font-medium group-hover:gap-3 transition-all duration-200"
              style={{ color: '#C9A84C', fontFamily: 'Roboto, sans-serif' }}>
              
              Learn more
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path
                  d="M3 7H11M11 7L7.5 3.5M11 7L7.5 10.5"
                  stroke="#C9A84C"
                  strokeWidth="1.2"
                  strokeLinecap="round"
                  strokeLinejoin="round" />
                
              </svg>
            </span>
          </div>

          {/* Right: Stats */}
          <div className="flex-shrink-0 flex gap-8 md:gap-12">
            {[
            { value: '50K+', label: 'Events Listed' },
            { value: '2M+', label: 'Tickets Sold' },
            { value: '180+', label: 'Cities' }]?.
            map((stat) =>
            <div key={stat?.label} className="text-center">
                <div
                className="text-3xl font-bold mb-1"
                style={{ fontFamily: '"Playfair Display", Georgia, serif', color: '#C9A84C' }}>
                
                  {stat?.value}
                </div>
                <div className="text-xs" style={{ color: 'rgba(250,247,242,0.5)', fontFamily: 'Roboto, sans-serif' }}>{stat?.label}</div>
              </div>
            )}
          </div>
        </div>
      </div>
    </Link>);

}